export default __webpack_public_path__ + "static/article-parents-share-their-best-financial-tips-14cf698d81545f9634fe5765e0c0f5e5.jpg";